import axios from 'config/axiosConfig'
import { go } from "keys/apis"
import { isArray } from 'lodash';

export const sendMessageFetch = (values) => {
    let formData = new FormData();
    for (const key in values) {
        if (isArray(values[key]))//for contentImages
            values[key].forEach((image) => {
                formData.append(key, image); // 'images' הוא השם של השדה במודל
            });

        else formData.append(key, values[key]);
    }
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${go}messages/`,
        formData
    )
}
